export default __webpack_public_path__ + "static/media/payQart.16479b19.png";